"use client";
import { NewSourcingRequestSchema } from "@/app/(procure)/procure/requests/types";
import constate from "constate";
import { useState } from "react";

function useSourcingRequestStore() {
  const [requestImages, setRequestImages] = useState<{
    [index: number]: { url: string; assetStorageKey?: string }[];
  }>({});
  const [files, setFiles] = useState<{ [index: number]: File[] }>({});
  const [expandedIndex, setExpandedIndex] = useState<number | null>(0);
  const [items, setItems] = useState<NewSourcingRequestSchema>();
  const deleteImage = (itemIndex: number, imageIndex: number) => {
    setRequestImages((prev) => ({
      ...prev,
      [itemIndex]: prev[itemIndex].filter((_, i) => i !== imageIndex),
    }));
    setFiles((prev) => ({
      ...prev,
      [itemIndex]: prev[itemIndex].filter((_, i) => i !== imageIndex),
    }));
  };

  const deleteAllImagesAtIndex = (itemIndex: number) => {
    setRequestImages((prev) => ({
      ...prev,
      [itemIndex]: [],
    }));
    setFiles((prev) => ({
      ...prev,
      [itemIndex]: [],
    }));
  };

  const handleNext = (fields: { length: number }) => {
    setExpandedIndex((prev) => {
      if (prev === null) return 0;
      if (prev >= fields.length - 1) return 0;
      return prev + 1;
    });
  };

  const handlePrevious = (fields: { length: number }) => {
    setExpandedIndex((prev) => {
      if (prev === null) return fields.length - 1;
      if (prev <= 0) return fields.length - 1;
      return prev - 1;
    });
  };
  const handleRemove = (index: number, fields: { length: number }) => {
    deleteAllImagesAtIndex(index);
    setExpandedIndex((prev) => {
      if (prev === null) return null;
      if (prev > index) return prev - 1;
      if (prev === index)
        return index > 0 ? index - 1 : fields.length > 1 ? 0 : null;
      return prev;
    });
  };

  const toggleExpand = (index: number) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };
  return {
    files,
    setFiles,
    requestImages,
    setRequestImages,
    deleteImage,
    deleteAllImagesAtIndex,
    handleNext,
    handlePrevious,
    handleRemove,
    setExpandedIndex,
    expandedIndex,
    items,
    setItems,
    toggleExpand,
  };
}

export const [SourcingRequestProvider, useSourcingRequestContext] = constate(
  useSourcingRequestStore,
);
